import { render, staticRenderFns } from "./ChoiceQuestionEdit.vue?vue&type=template&id=033649da&scoped=true"
import script from "./ChoiceQuestionEdit.vue?vue&type=script&lang=js"
export * from "./ChoiceQuestionEdit.vue?vue&type=script&lang=js"
import style0 from "./ChoiceQuestionEdit.vue?vue&type=style&index=0&id=033649da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033649da",
  null
  
)

export default component.exports